
const state = {
    tdk: []
}
const mutations = {
    clickTdkSearch(state,value) {
        console.log(value)
        state.tdk = value
    }
}
export default {
    namespaced: true,
    state,
    mutations
}